module.exports = __webpack_public_path__ + "static/media/closegrey.3e6fe297.svg";